import { library } from "@fortawesome/fontawesome-svg-core";

import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import { faUser } from "@fortawesome/free-solid-svg-icons/faUser";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons/faShoppingCart";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons/faEllipsisV";
import { faSitemap } from "@fortawesome/free-solid-svg-icons/faSitemap";
import { faMap } from "@fortawesome/free-solid-svg-icons/faMap";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons/faMapMarker";
import { faPhone } from "@fortawesome/free-solid-svg-icons/faPhone";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons/faEnvelope";
import { faFacebook } from "@fortawesome/free-brands-svg-icons/faFacebook";
import { faTwitter } from "@fortawesome/free-brands-svg-icons/faTwitter";
import { faYoutube } from "@fortawesome/free-brands-svg-icons/faYoutube";
import { faInstagram } from "@fortawesome/free-brands-svg-icons/faInstagram";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { faMobile } from "@fortawesome/free-solid-svg-icons/faMobile";
import { faCloud } from "@fortawesome/free-solid-svg-icons/faCloud";
import { faAndroid } from "@fortawesome/free-brands-svg-icons/faAndroid";
import { faApple } from "@fortawesome/free-brands-svg-icons/faApple";
import { faLightbulb } from "@fortawesome/free-solid-svg-icons/faLightbulb";
import { faStopwatch } from "@fortawesome/free-solid-svg-icons/faStopwatch";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons/faPaperPlane";
import { faMoneyBillAlt } from "@fortawesome/free-solid-svg-icons/faMoneyBillAlt";
import { faTabletAlt } from "@fortawesome/free-solid-svg-icons/faTabletAlt";
import { faDatabase } from "@fortawesome/free-solid-svg-icons/faDatabase";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { faSignal } from "@fortawesome/free-solid-svg-icons/faSignal";
import { faBatteryFull } from "@fortawesome/free-solid-svg-icons/faBatteryFull";
import { faBolt } from "@fortawesome/free-solid-svg-icons/faBolt";
import { faHdd } from "@fortawesome/free-solid-svg-icons/faHdd";
import { faCube } from "@fortawesome/free-solid-svg-icons/faCube";
import { faBluetooth } from "@fortawesome/free-brands-svg-icons/faBluetooth";
import { faCompass } from "@fortawesome/free-solid-svg-icons/faCompass";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons/faPaperclip";
import { faWifi } from "@fortawesome/free-solid-svg-icons/faWifi";
import { faUsers } from "@fortawesome/free-solid-svg-icons/faUsers";
import { faChrome } from "@fortawesome/free-brands-svg-icons/faChrome";
import { faSafari } from "@fortawesome/free-brands-svg-icons/faSafari";
import { faFirefox } from "@fortawesome/free-brands-svg-icons/faFirefox";
import { faOpera } from "@fortawesome/free-brands-svg-icons/faOpera";
import { faEdge } from "@fortawesome/free-brands-svg-icons/faEdge";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import { faSync } from "@fortawesome/free-solid-svg-icons/faSync";
import { faCamera } from "@fortawesome/free-solid-svg-icons/faCamera";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons/faBriefcase";
import { faLock } from "@fortawesome/free-solid-svg-icons/faLock";
import { faThumbtack } from "@fortawesome/free-solid-svg-icons/faThumbtack";
import { faCheck } from "@fortawesome/free-solid-svg-icons/faCheck";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons/faExclamationTriangle";
import { faFolderOpen } from "@fortawesome/free-solid-svg-icons/faFolderOpen";
import { faTrash } from "@fortawesome/free-solid-svg-icons/faTrash";
import { faFile } from "@fortawesome/free-solid-svg-icons/faFile";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons/faPlusCircle";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import { faClock } from "@fortawesome/free-solid-svg-icons/faClock";
import { faPrint } from "@fortawesome/free-solid-svg-icons/faPrint";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faIndustry } from "@fortawesome/free-solid-svg-icons/faIndustry";
import { faUniversity } from "@fortawesome/free-solid-svg-icons/faUniversity";
import { faCcVisa } from "@fortawesome/free-brands-svg-icons/faCcVisa";
import { faCcMastercard } from "@fortawesome/free-brands-svg-icons/faCcMastercard";
import { faCcAmex } from "@fortawesome/free-brands-svg-icons/faCcAmex";
import { faCcDiscover } from "@fortawesome/free-brands-svg-icons/faCcDiscover";
import { faCcJcb } from "@fortawesome/free-brands-svg-icons/faCcJcb";
import { faCcDinersClub } from "@fortawesome/free-brands-svg-icons/faCcDinersClub";
import { faCreditCard } from "@fortawesome/free-solid-svg-icons/faCreditCard";
import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faCloudDownloadAlt } from "@fortawesome/free-solid-svg-icons/faCloudDownloadAlt";
import { faEdit } from "@fortawesome/free-solid-svg-icons/faEdit";

//font awesome icons library
library.add(
  faBars,
  faUser,
  faShoppingCart,
  faEllipsisV,
  faSitemap,
  faMap,
  faMapMarker,
  faPhone,
  faEnvelope,
  faFacebook,
  faTwitter,
  faYoutube,
  faInstagram,
  faArrowRight,
  faMobile,
  faCloud,
  faAndroid,
  faApple,
  faLightbulb,
  faStopwatch,
  faPaperPlane,
  faMoneyBillAlt,
  faTabletAlt,
  faDatabase,
  faGlobe,
  faSignal,
  faBatteryFull,
  faBolt,
  faHdd,
  faCube,
  faBluetooth,
  faCompass,
  faPaperclip,
  faWifi,
  faUsers,
  faChrome,
  faSafari,
  faFirefox,
  faOpera,
  faEdge,
  faCheckCircle,
  faSync,
  faCamera,
  faBriefcase,
  faLock,
  faThumbtack,
  faCheck,
  faExclamationTriangle,
  faFolderOpen,
  faTrash,
  faFile,
  faPlusCircle,
  faTimes,
  faArrowLeft,
  faInfoCircle,
  faClock,
  faPrint,
  faSearch,
  faIndustry,
  faUniversity,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcDiscover,
  faCcJcb,
  faCcDinersClub,
  faCreditCard,
  faBan,
  faCloudDownloadAlt,
  faEdit
);
